import React, { useState } from 'react';
import UbicacionEnMapa, { guardarUbicacionManual } from '../mapa/UbicacionEnMapa';
import { toast } from 'react-hot-toast';

// Alta o edición de un lugar (sede). La dirección completa se arma con calle, número, piso,
// depto y localidad, igual que antes, para que el mapa la encuentre.
const INPUT = 'w-full h-11 px-3.5 rounded-xl bg-chip text-ink text-body font-bold outline-none border border-black/[0.07] dark:border-white/[0.07] focus:ring-2 focus:ring-[#D13A28]/20 focus:border-[#D13A28] placeholder:text-muted placeholder:font-medium';
const LABEL = 'block text-label font-black uppercase tracking-widest text-muted mb-1';

const armarDireccion = f => {
    const base = [f.calle, f.numero].map(x => (x || '').trim()).filter(Boolean).join(' ');
    const extra = [f.piso ? `Piso ${f.piso}` : '', f.depto ? `Depto ${f.depto}` : ''].filter(Boolean).join(' ');
    return [base, extra, (f.localidad || '').trim()].filter(Boolean).join(', ');
};

export default function SedeForm({ inicial, onGuardar, onCancelar }) {
    const [f, setF] = useState(() => ({
        nombreSede: inicial?.nombreSede || '', calle: inicial?.calle || '', numero: inicial?.numero || '',
        piso: inicial?.piso || '', depto: inicial?.depto || '', localidad: inicial?.localidad || '',
        provincia: inicial?.provincia || 'Buenos Aires', notas: inicial?.notas || '',
    }));
    // Lugares viejos solo tienen la dirección escrita de una (sin calle/número separados)
    const soloTexto = !!inicial && !inicial.calle && !!inicial.direccion;
    const [direccionLibre, setDireccionLibre] = useState(soloTexto ? inicial.direccion : '');
    const [guardando, setGuardando] = useState(false);
    const [punto, setPunto] = useState(null);
    const set = k => e => setF(p => ({ ...p, [k]: e.target.value }));

    const guardar = async (e) => {
        e.preventDefault();
        if (!f.nombreSede.trim()) { toast.error('Poné un nombre para el lugar'); return; }
        const direccion = soloTexto && !f.calle.trim() ? direccionLibre.trim() : armarDireccion(f);
        if (!direccion) { toast.error('Cargá la dirección (calle y número)'); return; }
        setGuardando(true);
        await guardarUbicacionManual(direccion, punto);
        const ok = await onGuardar({ ...f, nombreSede: f.nombreSede.trim(), direccion });
        if (!ok) setGuardando(false);
    };

    return (
        <form onSubmit={guardar} className="space-y-3">
            <p className="text-body font-black text-ink">{inicial ? `Editar · ${inicial.nombreSede}` : 'Nuevo lugar'}</p>
            <div>
                <label className={LABEL}>Nombre</label>
                <input className={INPUT} value={f.nombreSede} onChange={set('nombreSede')} placeholder="Ej: 2466 - Susana, Depósito, Sucursal centro" autoFocus />
            </div>
            {soloTexto && (
                <div>
                    <label className={LABEL}>Dirección actual</label>
                    <input className={INPUT} value={direccionLibre} onChange={e => setDireccionLibre(e.target.value)} />
                    <p className="text-label text-muted mt-1">Este lugar tiene la dirección escrita de una. Podés corregirla acá, o cargar calle y número abajo para reemplazarla.</p>
                </div>
            )}
            <div className="grid grid-cols-3 gap-2">
                <div className="col-span-2"><label className={LABEL}>Calle</label><input className={INPUT} value={f.calle} onChange={set('calle')} placeholder="Calle" /></div>
                <div><label className={LABEL}>Número</label><input className={INPUT} value={f.numero} onChange={set('numero')} placeholder="Nº" inputMode="numeric" /></div>
            </div>
            <div className="grid grid-cols-3 gap-2">
                <div><label className={LABEL}>Piso</label><input className={INPUT} value={f.piso} onChange={set('piso')} placeholder="—" /></div>
                <div><label className={LABEL}>Depto</label><input className={INPUT} value={f.depto} onChange={set('depto')} placeholder="—" /></div>
                <div><label className={LABEL}>Localidad</label><input className={INPUT} value={f.localidad} onChange={set('localidad')} placeholder="Localidad" /></div>
            </div>
            <UbicacionEnMapa direccion={soloTexto && !f.calle.trim() ? direccionLibre : armarDireccion(f)} onCambio={setPunto}
                onDireccion={soloTexto ? null : d => setF(p => ({ ...p, calle: d.calle || p.calle, numero: d.numero, localidad: d.localidad || p.localidad }))} />
            <div>
                <label className={LABEL}>Notas</label>
                <textarea className={`${INPUT} h-auto py-2.5 resize-none font-medium`} rows={2} value={f.notas} onChange={set('notas')} placeholder="Horarios, cómo entrar, a quién preguntar…" />
            </div>
            <p className="text-caption text-muted">Dirección: <b className="text-ink">{(soloTexto && !f.calle.trim() ? direccionLibre : armarDireccion(f)) || '—'}</b></p>
            <div className="flex gap-2 pt-1">
                <button type="button" onClick={onCancelar} className="flex-1 h-11 rounded-xl bg-chip text-secondary text-label font-black active:scale-95">Cancelar</button>
                <button type="submit" disabled={guardando}
                    className="flex-[2] h-11 rounded-xl bg-brand-red text-white text-label font-black active:scale-95 disabled:opacity-50">
                    {guardando ? 'Guardando…' : inicial ? 'Guardar cambios' : 'Agregar lugar'}
                </button>
            </div>
        </form>
    );
}
